import type { DivisionCategoryFlags, TopLevelCategoryFlags } from '~~/server/flags/constants/categoryData';
import type { ProductFlags } from '~~/server/pageData/featureControl/constants/productFlagsList';
import type { FeatureEligibleFlags } from '~~/server/pageData/featureControl/mappers/featureEligible';

export const PRODUCT_ID_REPOSITORY: InjectionKey<ProductId> = Symbol.for('PRODUCT_ID_REPOSITORY');
export const PRODUCT_DATA_REPOSITORY: InjectionKey<Product> = Symbol.for('PRODUCT_DATA_REPOSITORY');

export const PRODUCT_FLAGS_REPOSITORY: InjectionKey<ProductFlags> = Symbol.for('PRODUCT_FLAGS_REPOSITORY');

export const PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY: InjectionKey<TopLevelCategoryFlags> = Symbol.for(
  'PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY',
);

export const PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY: InjectionKey<DivisionCategoryFlags> = Symbol.for(
  'PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY',
);

export const PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY: InjectionKey<FeatureEligibleFlags> = Symbol.for('PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY');
export const PRODUCT_QUANTITY_REPOSITORY: InjectionKey<{ quantity: WritableComputedRef<number>; minQuantity: number; maxQuantity: number }> =
  Symbol.for('PRODUCT_QUANTITY_REPOSITORY');
export const PRODUCT_PRICE_REPOSITORY = Symbol.for('PRODUCT_PRICE_REPOSITORY');
